<template>
  <sc-card :title="$t('layers')" v-loading="isLoading" v-if="type === `card`">
    <div class="sc-layer-controller card">
      <ul class="sc-layer-controller__list" v-if="allMapLayersList.length">
        <li
          :class="[
            `sc-layer-controller__list-item`,
            { active: isLayerActive(layer) }
          ]"
          v-for="layer in allMapLayersList"
          :key="layer"
          @click="toggleLayer(layer)"
        >
          <r-text>{{ $t(layer) }}</r-text>
        </li>
        <li
          v-if="hasMatrixLayer"
          :class="[
            'sc-layer-controller__list-item',
            { active: isMatrixActive }
          ]"
          @click="toggleLayer('matrix')"
        >
          <r-text :size="16">{{ $t(layer) }}</r-text>
        </li>
      </ul>
    </div>
  </sc-card>
  <div class="sc-layer-controller default" v-else>
    <ul class="sc-layer-controller__list" v-if="mapLayersList.length">
      <el-tooltip
        :open-delay="500"
        :content="$t(layer)"
        placement="bottom"
        v-for="layer in mapLayersList"
        :key="layer"
      >
        <li
          :class="[
            `sc-layer-controller__list-item`,
            { active: isLayerActive(layer) }
          ]"
          @click="toggleLayer(layer)"
          @mouseover="showInfo(layer, true)"
        >
          <tagil-pt-filterable
            :layer_id="layer"
            v-if="layer === 'TagilPublicTransport?format=vehicles'"
            :isVisible="isVisible"
            @closeFilter="showInfo(layer, false)"
          />
          <r-icon :name="getIconName(layer)" :size="24" v-else />
        </li>
      </el-tooltip>

      <el-tooltip
        v-if="activeSC && hasMatrixLayer"
        :open-delay="500"
        :content="$t('matrix')"
        placement="bottom"
      >
        <li
          :class="[
            `sc-layer-controller__list-item`,
            { active: isMatrixActive }
          ]"
          @click="toggleLayer('matrix')"
        >
          <r-icon name="heatmap" :size="18" />
        </li>
      </el-tooltip>

      <el-tooltip
        v-if="instance === 'tagil'"
        :open-delay="500"
        :content="$t('matrix-tagil')"
        placement="top"
      >
        <li
          :class="[
            `sc-layer-controller__list-item`,
            { active: isTagilMatrixActive }
          ]"
        >
          <tagil-matrix />
        </li>
      </el-tooltip>

      <el-tooltip
        v-if="instance === 'tagil'"
        :open-delay="500"
        :content="$t('pt-route')"
        placement="top"
      >
        <li
          :class="[
            `sc-layer-controller__list-item`,
            { active: isLayerActive('ptRoute') }
          ]"
          @click="toggleLayer('ptRoute')"
        >
          <r-icon name="line" :size="18" />
        </li>
      </el-tooltip>
    </ul>
    <el-dropdown
      v-if="tileLayersList.length"
      class="r-dropdown sc-layer-controller__dropdown"
      size="mini"
      :hide-on-click="false"
      :show-timeout="100"
      placement="bottom-start"
      trigger="click"
      @visible-change="e => tileToggleHandler(e)"
    >
      <div :class="['r-dropdown__item', { active: isTileDropdownShow }]">
        <r-icon
          name="layers-folder"
          :size="24"
          style="cursor: pointer"
          arrow-down
        />
      </div>
      <el-dropdown-menu slot="dropdown" class="r-dropdown-menu">
        <el-dropdown-item v-for="layer in tileLayersList" :key="layer">
          <div
            class="r-dropdown-menu__item-wrapper"
            @click="toggleLayer(layer)"
          >
            <el-checkbox
              class="r-checkbox"
              size="mini"
              :value="isLayerActive(layer)"
              @change="toggleLayer(layer)"
            />
            <r-text style="margin-left: 12px">
              {{ $t(layer) }}
            </r-text>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown
      v-if="tomtomLayersList.length"
      class="r-dropdown sc-layer-controller__dropdown"
      size="mini"
      :hide-on-click="false"
      :show-timeout="100"
      placement="bottom-start"
      trigger="click"
      @visible-change="e => toggleHandler(e)"
    >
      <div :class="['r-dropdown__item', { active: isDropdownShow }]">
        <r-icon name="tomtom" :size="24" style="cursor: pointer" arrow-down />
      </div>
      <el-dropdown-menu slot="dropdown" class="r-dropdown-menu">
        <el-dropdown-item v-for="layer in tomtomLayersList" :key="layer">
          <div
            class="r-dropdown-menu__item-wrapper"
            @click="toggleLayer(layer)"
          >
            <el-checkbox
              class="r-checkbox"
              size="mini"
              :value="isLayerActive(layer)"
              @change="toggleLayer(layer)"
            />
            <r-text style="margin-left: 12px">
              {{ $t(layer) }}
            </r-text>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown
      v-if="mapPODDLayersList.length"
      class="r-dropdown sc-layer-controller__dropdown"
      size="mini"
      :hide-on-click="false"
      :show-timeout="100"
      placement="bottom-start"
      trigger="click"
      @visible-change="e => toggleHandler(e)"
    >
      <div :class="['r-dropdown__item', { active: isDropdownShow }]">
        <r-icon name="podd" :size="24" style="cursor: pointer" arrow-down />
      </div>
      <el-dropdown-menu slot="dropdown" class="r-dropdown-menu">
        <el-dropdown-item v-for="layer in mapPODDLayersList" :key="layer">
          <div
            class="r-dropdown-menu__item-wrapper"
            @click="toggleLayer(layer)"
          >
            <el-checkbox
              class="r-checkbox"
              size="mini"
              :value="isLayerActive(layer)"
              @change="toggleLayer(layer)"
            />
            <r-text style="margin-left: 12px">
              {{ $t(layer) }}
            </r-text>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import scCard from "../../layout/card";
import tagilMatrix from "./tagil-matrix";
import tagilPtFilterable from "./tagil-pt-filterable";

import { getWidgetStyleConfig } from "../../../configs";

export default {
  props: {
    type: {
      type: String,
      default: "default"
    }
  },
  components: { scCard, tagilMatrix, tagilPtFilterable },
  data() {
    return {
      isTileDropdownShow: false,
      isDropdownShow: false,
      isLoading: false,
      isVisible: false
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    disabledLayers() {
      return this.$store.state.situationCenter.disabledLayers;
    },
    allMapLayersList() {
      const mapLayers =
        Object.keys(this.$store.state.situationCenter.layersData.map).sort(
          (a, b) => {
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
          }
        ) || [];
      const mapTileLayers = this.$store.state.situationCenter.config
        .mapTileLayers
        ? this.$store.state.situationCenter.config.mapTileLayers.map(e => e.id)
        : [];

      return mapLayers.concat(mapTileLayers);
    },
    mapLayersList() {
      const mapLayers =
        Object.keys(this.$store.state.situationCenter.layersData.map).sort(
          (a, b) => {
            if (a > b) return 1;
            if (a < b) return -1;
            return 0;
          }
        ) || [];
      return mapLayers;
    },
    tileLayersList() {
      const mapTileLayers = this.$store.state.situationCenter.config
        .mapTileLayers
        ? this.$store.state.situationCenter.config.mapTileLayers.map(e => e.id)
        : [];

      return mapTileLayers.filter(
        e => e.indexOf("podd") === -1 && e.indexOf("tomtom") === -1
      );
    },
    tomtomLayersList() {
      const mapTileLayers = this.$store.state.situationCenter.config
        .mapTileLayers
        ? this.$store.state.situationCenter.config.mapTileLayers.map(e => e.id)
        : [];

      return mapTileLayers.filter(e => e.indexOf("tomtom") !== -1);
    },
    mapPODDLayersList() {
      const mapTileLayers = this.$store.state.situationCenter.config
        .mapTileLayers
        ? this.$store.state.situationCenter.config.mapTileLayers.map(e => e.id)
        : [];

      return mapTileLayers.filter(e => e.indexOf("podd") !== -1);
    },
    activeSC() {
      return this.$store.state.situationCenter.activeSC || null;
    },
    hasMatrixLayer() {
      return this.$store.state.situationCenter.config.hasMatrix;
    },
    isTagilMatrixActive() {
      return this.$store.state.situationCenter.tagilMatrix.enabled;
    },
    isMatrixActive() {
      return this.$store.state.situationCenter.matrix.enabled;
    }
  },
  methods: {
    showInfo(layer, switcher) {
      if (
        layer === "TagilPublicTransport?format=vehicles" &&
        this.isLayerActive(layer)
      ) {
        this.isVisible = switcher;
      }
    },
    toggleHandler(val) {
      this.isDropdownShow = val;
    },
    tileToggleHandler(val) {
      this.isTileDropdownShow = val;
    },
    async toggleLayer(layer_id) {
      if (
        layer_id === "TagilPublicTransport?format=vehicles" &&
        this.isLayerActive(layer_id)
      ) {
        this.isVisible = false;
      }

      if (layer_id === "matrix") {
        this.$store.commit("SET_SI_CENTER_MATRIX_PROP", {
          field: "enabled",
          value: !this.isMatrixActive
        });
      } else {
        this.$store.commit("TOGGLE_SI_CENTER_ACTIVE_LAYERS", layer_id);
      }
      try {
        await this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
      } catch (e) {
        console.log(e);
      }
    },
    isLayerActive(layer_id) {
      return this.disabledLayers.indexOf(layer_id) === -1;
    },
    getIconName(layer_id) {
      const styleConfig = getWidgetStyleConfig(layer_id);

      return styleConfig ? styleConfig.icons.default : "layers-folder";
    }
  }
};
</script>

<style lang="scss">
.sc-layer-controller {
  width: 300px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  &__list {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    padding-right: 4px;
    &-item {
      padding: 8px 16px;
      border-radius: var(--border-radius);
      margin-bottom: 2px;
      flex-direction: column;
      cursor: pointer;
      transition: all 0.15s ease;
      &:last-child {
        margin-bottom: 0;
      }
      &:hover {
        background-color: rgba(var(--accent_primary), 0.15) !important;
      }
      &.active {
        background-color: var(--accent_primary) !important;
        .r-text {
          color: var(--white_white) !important;
        }
      }
      &:active {
        background-color: rgba(var(--accent_primary), 0.45) !important;
      }
    }
  }
  &.default {
    width: auto;
    height: auto;
    .sc-layer-controller__dropdown {
      margin-left: 8px;
      padding: 4px;
      display: flex;
      border-radius: var(--border-radius);
      background-color: var(--modal_bg) !important;
      box-shadow: 0px 3px 6px #00000029;
      .r-dropdown__item {
        padding: 0 4px;
      }
    }
    .sc-layer-controller__list {
      display: flex;
      border-radius: var(--border-radius);
      padding: 4px;
      background-color: var(--modal_bg) !important;
      box-shadow: 0px 3px 6px #00000029;
      &-item {
        display: flex;
        min-width: 36px;
        min-height: 36px;
        max-width: 36px;
        max-height: 36px;
        border-radius: var(--border-radius);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
        margin: 0 4px 0 0;
        outline: none !important;
        position: relative;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          background-color: rgba(var(--accent_primary), 0.15) !important;
        }
        &.active {
          background-color: var(--accent_selected) !important;
          .r-text {
            color: var(--white_white) !important;
          }
          .r-icon__svg {
            fill: var(--white_white) !important;
          }
        }
        &:active {
          background-color: rgba(var(--accent_primary), 0.45) !important;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "matrix-tagil": "Корреспонденции"
  },
  "en": {
    "matrix-tagil": "Correspondence"
  }
}
</i18n>
